
import React from 'react'
import { MDXTag } from '@mdx-js/tag'


export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="h1" components={components} props={{"id":"building-swift-shop---week-4-dec-8---14-2019"}}>{`Building Swift Shop - Week 4 (Dec 8 − 14, 2019)`}</MDXTag>
<MDXTag name="h4" components={components} props={{"id":"dec-15-2019"}}>{`Dec 15, 2019`}</MDXTag>
<MDXTag name="p" components={components}>{`This week, persistence via GRDB was added, and some basic entity associations were set up to run a simple test view:`}</MDXTag>
<div align="center">
  <video controls alt="Week 4 - Debug View">
    <source src="https://giant.gfycat.com/FloweryWaterloggedAnophelesmosquito.mp4" type="video/mp4" />
  </video>
</div>
<MDXTag name="p" components={components}>{`The test view consists of:`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul">{`A button to populate the database with some placeholder data`}<MDXTag name="ul" components={components} parentName="li">
<MDXTag name="li" components={components} parentName="ul">{`A list “Main List”`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`A product “first product”`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`A tag “MyTag”`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`Associations between types; the product has “MyTag” and is in “Main List”`}</MDXTag>
</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`A button to add a second placeholder tag to the product`}</MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`A button to subscribe to the “ListedItems” publisher`}</MDXTag>
</MDXTag>
<MDXTag name="p" components={components}>{`This was mostly to test that the associations between types, and that the list will react to changes in any of the entities being used (ListEntity, ProductEntity, ProductStateEntity, ProductTagEntity)`}</MDXTag>
<MDXTag name="p" components={components}>{`After the debug view was working, I did a first pass on the products list view, as well as added a slide-up sheet for editing or creating products (doesn’t do tags yet).`}</MDXTag>
<div align="center">
  <video controls alt="Week 4 - Products List Page">
    <source src="https://giant.gfycat.com/LightSeriousFattaileddunnart.webm" type="video/mp4" />
  </video>
</div>
<MDXTag name="p" components={components}>{`The slide-up sheet is a View extension package called PartialSheet, which can be found on GitHub:`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{"href":"https://github.com/AndreaMiotto/PartialSheet"}}>{`https://github.com/AndreaMiotto/PartialSheet`}</MDXTag></MDXTag>
           </MDXTag>
  }
}
export const tableOfContents = (components={}) => [
  
]

export const frontMatter = {}

